import Grid from "@mui/material/Grid2";
import { InsightSiteMap } from "@/components/molecules";
import { LocationResult, PenPortraitInsightVariable } from "@/types";
import React from "react";

interface MapViewProps {
  locations: LocationResult;
  scores?: PenPortraitInsightVariable[];
}

export const SiteView: React.FC<MapViewProps> = ({ locations, scores }) => {
  return (
    <Grid container size={12} spacing={2} flexGrow={1}>
      <InsightSiteMap locationScores={locations} siteScores={scores} />
    </Grid>
  );
};

export default SiteView;
